import { fg } from '@atlaskit/platform-feature-flags';
import { isIPad, isIPhone } from '../../../../jira-common/utils/native/detectDeviceType';
export var getDropDownMenuPosition = function getDropDownMenuPosition() {
  return fg('jsm-request-intake-jac-fixes') ? {
    menuPosition: 'absolute',
    menuPlacement: 'auto'
  } : isIPhone() || isIPad() ?
  // This is to prevent menu floating away due to virtual keyboard in iPad and iPhone
  {
    menuPosition: 'absolute'
  } : {
    menuPosition: 'fixed'
  };
};